"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fullstory = void 0;
const app_1 = require("@koopajs/app");
const FullStory = require("@fullstory/browser");
const lodash_1 = require("lodash");
class Fullstory extends app_1.Plugins.Abstract {
    constructor() {
        super();
        this.key = 'fullstory';
        app_1.Bus.onConfigReady(({ fullstory }) => {
            if (lodash_1.isEmpty(fullstory)) {
                return console.warn('Fullstory extension is activated but backend config did not provide a `fullstory` value');
            }
            FullStory.init(fullstory);
            this.dispatchSuccess({});
        });
        app_1.Bus.onUserReady(({ userId }) => {
            FullStory.identify(userId);
        });
    }
}
exports.Fullstory = Fullstory;
//# sourceMappingURL=index.js.map